import React from 'react';
import { useTranslation } from 'react-i18next';

const Parametre = () => {
    const { t } = useTranslation();

    return (
        <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
            {t('employeeProfile.parametreStub')}
        </div>
    );
}

export default Parametre;